'use client';

import { useLayoutDispatch, useLayoutState } from 'BomdisoftComponents/layout/context';
import { delegateLayoutDrawerResize } from 'BomdisoftComponents/layout/delegate';
import { getLanguageFromLocale, resizeDrawerT } from '@bomdisoft/translations';
import { useParams } from 'next/navigation';
import { useEffect, useRef } from 'react';

export const LayoutDrawerResize = ({ drawerId }: { drawerId: string }) => {
  const params = useParams();
  const language = getLanguageFromLocale(typeof params?.lang === 'string' ? params.lang : undefined);
  const dispatch = useLayoutDispatch();
  const drawerState = useLayoutState(state => state.drawers[drawerId]);
  const handle = useRef<HTMLHRElement>(null);
  const isRegistered = drawerState !== undefined;

  useEffect(() => {
    if (!isRegistered || handle.current === null) return undefined;
    return delegateLayoutDrawerResize(handle.current, { onResize: width => dispatch({ id: drawerId, type: 'RESIZE_DRAWER', width }) });
  }, [dispatch, drawerId, isRegistered]);

  if (!drawerState) return null;

  return <hr aria-label={resizeDrawerT[language]} aria-orientation='vertical' aria-valuemax={drawerState.maxWidth} aria-valuemin={drawerState.minWidth} aria-valuenow={drawerState.width} className='bomdisoft-layout-resize-handle' data-testid='layout-drawer-resize' ref={handle} tabIndex={0} />;
};
